export type FAQItem = {
  question: string;
  answer: string;
};

export const generalFaqs: FAQItem[] = [
  {
    question: 'What products does ZFAST Agritech India manufacture and supply?',
    answer:
      'ZFAST Agritech India manufactures and supplies premium animal nutrition products including Cattle Feed (ZFAST 10000, Z-30 Pro, Z-8000), complete Swine / Pig Feed (Starter, Grower, Finisher, Sow Gestation, Sow Lactation), and pure Edible Oils (Z-Strong Mustard Oil, Soybean Refined Oil, and Sunflower Oil).'
  },
  {
    question: 'Where is ZFAST Agritech India located?',
    answer:
      'ZFAST Agritech India is headquartered at 503, Shree GD Tower, Ajmer Rd, Neelkanth Colony, Vaishali Nagar, Jaipur, Rajasthan 302006, serving farmers, dealers, and distributors across India.'
  },
  {
    question: 'How can I become a dealer or distributor for ZFAST products?',
    answer:
      'Interested dealers and distributors can apply through the Dealer Partnership page on our website or contact our team directly at +91 98120 13300 or info@zfastagritechindia.com for territory availability and supply details.'
  }
];

export const cattleFaqs: FAQItem[] = [
  {
    question: 'Which cattle feed is best for high-yielding dairy cows and buffaloes?',
    answer:
      'ZFAST 10000 is our flagship premium cattle feed formulated with high protein, balanced energy, bypass nutrients, and essential minerals to support high-yield dairy animals, peak lactation, and body condition.'
  },
  {
    question: 'What is the difference between ZFAST 10000, Z-30 Pro, and Z-8000 cattle feed?',
    answer:
      'ZFAST 10000 is formulated for high-yielding commercial dairy cattle requiring intensive nutrition. Z-30 Pro supports medium-to-high yielding animals during standard lactation, while Z-8000 provides balanced everyday nutrition for maintenance and steady milk production.'
  },
  {
    question: 'How does ZFAST Agritech control aflatoxin in cattle feed?',
    answer:
      'ZFAST follows rigorous incoming raw material screening, moisture control, certified laboratory batch testing, and hygienic storage practices to keep aflatoxin levels well within safe regulatory limits.'
  },
  {
    question: 'Can one cattle feed work for every animal?',
    answer:
      'No. Feed choice should consider animal age, lactation stage, breed, current health, roughage availability, water access, and local farm management conditions.'
  },
  {
    question: 'How should cattle feed bags be stored on the farm?',
    answer:
      'Keep feed bags elevated on wooden pallets in a dry, well-ventilated, pest-controlled shed away from direct sunlight, rain, and floor moisture.'
  }
];

export const pigFaqs: FAQItem[] = [
  {
    question: 'What stage-specific pig feeds does ZFAST offer?',
    answer:
      'ZFAST offers a complete swine nutrition range: Pig Starter (early post-weaning growth & gut health), Pig Grower (steady skeletal and muscle development), Pig Finisher (optimal weight gain & carcass quality), Sow Gestation (fetal growth & sow body condition), and Sow Lactation (milk output & litter vitality).'
  },
  {
    question: 'How does ZFAST Pig Starter support piglet immunity and growth?',
    answer:
      'ZFAST Pig Starter contains highly digestible proteins, balanced amino acid profiles, and gut-health support to ease the post-weaning transition, prevent diarrhea, and encourage steady feed intake.'
  },
  {
    question: 'Why is stage-wise feeding important in commercial pig farming?',
    answer:
      'Pigs require different protein-to-energy ratios and mineral densities at each growth phase. Stage-wise feeding optimizes feed conversion ratio (FCR), lowers feed wastage, and maximizes profitability.'
  }
];

export const farmerFaqs: FAQItem[] = [
  ...cattleFaqs,
  {
    question: 'How can farmers calculate cattle and pig body weight without a scale?',
    answer:
      'Farmers can use the free Cattle Weight Calculator and Pig Weight Calculator in our Farmer Corner by measuring heart girth and body length to estimate body weight accurately.'
  },
  {
    question: 'Do the feed pages guarantee milk increase?',
    answer:
      'No guaranteed milk increase is claimed. Nutrition can support farm routines, but actual results depend on genetics, health, roughage quality, water intake, and overall farm management.'
  }
];

export const oilFaqs: FAQItem[] = [
  {
    question: 'Which edible oils are supplied by ZFAST Agritech?',
    answer:
      'ZFAST supplies Z-Strong Mustard Oil (traditional pungent kachi ghani taste), Refined Soybean Oil (light, high smoke point for daily cooking), and Pure Sunflower Oil (ideal for deep frying and institutional food service).'
  },
  {
    question: 'Are edible oil prices available online?',
    answer:
      'Prices vary based on market rates, pack size (1L, 5L, 15L/15Kg tins, bulk drums), order volume, and destination. Contact our sales team for current commercial price quotes.'
  },
  {
    question: 'Can bulk buyers and institutional kitchens enquire?',
    answer:
      'Yes. We supply food service operators, institutional caterers, regional wholesalers, and modern retail distributors with customized bulk packing options.'
  }
];

export const qualityFaqs: FAQItem[] = [
  {
    question: 'What quality testing procedures are conducted at ZFAST?',
    answer:
      'Every batch undergoes strict raw material inspection, proximate analysis (crude protein, moisture, fat, fiber), aflatoxin screening, toxin binder verification, and physical pellet durability tests.'
  },
  {
    question: 'Are quality certificates provided to institutional buyers and dealers?',
    answer:
      'Yes. Certificates of Analysis (COA) and batch test parameters are available upon request for registered dealers and institutional supply orders.'
  }
];

